import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import {deletePageMedia, fetchPage} from "../../store/pages/actions";
import MediasService from '../../services/medias';
import MediaList from "../../components/media/MediaList/MediaList";
import withTranslation from "../../hoc/withTranslation";
import {EDIT_PAGE_MEDIA_PAGE} from "../../constants/routes";

export class PageMimeMediaListPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        page: PropTypes.object
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.pageId)
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.entity === null) {
            this.fetchPage(nextProps.app.id, nextProps.match.params.pageId);
        }
    }

    // Fetch

    fetch(appId = null, pageId = null) {
        this.fetchApplication(appId);
        this.fetchPage(appId, pageId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchPage(appId = null, pageId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const page = pageId || this.props.match.params.pageId;

            if (app && page) {
                this.props.fetchPage(app, page, this.props.lang);
            }
        }
    }

    // Handlers

    handleEditMedia = (media) => {
        let url = EDIT_PAGE_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':pageId', this.props.page.id)
            .replace(':mediaId', media.id);
        this.props.history.push(url);
    };

    handleDeleteMedia = (media) => {
        if (this.props.app && this.props.page) {
            this.props.deletePageMedia(this.props.app.id, this.props.page.id, media);
        }
    };

    // Render

    render() {
        let shortMime = this.props.match.params.shortMime;

        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.page) {
            return <Loading paper={false}/>;
        } else {
            let medias = MediasService.sortedMediasForShortMime(this.props.page.medias, shortMime);
            let mimeDisplayName = MediasService.displayNameForShortMime(shortMime);

            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media_plural')} / {mimeDisplayName} - {this.props.page.title}</h3>
                    <MediaList
                        title={mimeDisplayName}
                        medias={medias}
                        handleDeleteMedia={this.handleDeleteMedia}
                        handleEditMedia={this.handleEditMedia}
                    />
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.pages.pending,
        error: state.pages.error || state.apps.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        user: state.auth.content,
        page: state.pages.currentPage
    };
}

export default connect(mapStateToProps, {
    fetchApp,
    fetchPage,
    deletePageMedia
})(withTranslation(PageMimeMediaListPage));



// WEBPACK FOOTER //
// src/containers/page/PageMimeMediaListPage.js